import React from 'react';
import { faCodeCompare } from '@fortawesome/free-solid-svg-icons';
import BlogPost from '../BlogPost';
import tailOfTwoJourneysImg from '../../../assets/images/blogs/Tail of Two Journeys.png';

const TailOfTwoJourneys = () => (
    <BlogPost
        title="AI Native Semantics: A Tail of Two Journeys"
        subtitle="Two paths to semantics. Only one gets you there at the speed your market is about to demand."
        category="Strategy"
        categoryIcon={faCodeCompare}
        color="#003366"
        date="March 2026"
        readTime="4 min read"
        image={tailOfTwoJourneysImg}
        imageAlt="Two journeys to semantics - traditional ontology versus AI-native discovery"
        ctaHeading="Which path will you take?"
        ctaText="Book a discovery call and we'll show you how to get semantic capabilities in hours, not years."
        seoDescription="Comparing two approaches to semantic AI: 18-month ontology initiatives versus AI-native systems that deliver results in 30 minutes."
        seoKeywords="semantic AI, ontology, AI-native semantics, knowledge discovery, Nebulyx Cognition, clinical AI"
        slug="tail-of-two-journeys"
    >
        <p>
            Let me tell you about two companies.
        </p>

        <h3>Company A</h3>

        <p>
            Company A signs a $1M+ semantic layer initiative.
        </p>

        <p>
            18 months to model their domains, mapping relationships, defining contracts.
            Governance committees reviewing every entity.
        </p>

        <p>
            By Q3 next year, they'll have a foundation for AI. Then they spin up another
            initiative to build the AI solution to query the semantics.
        </p>

        <h3>Company B</h3>

        <p>
            Company B is in the same space.
        </p>

        <p>
            They point an AI-native semantics system at Harrison's Principles of Internal
            Medicine. 5,113 pages. One of the most comprehensive clinical references ever
            published.
        </p>

        <p>
            <strong>30 minutes later:</strong>
        </p>

        <p>
            • 122,312 sentences encoded<br />
            • 7,916 clinical concepts identified<br />
            • 22,224 domain terms discovered
        </p>

        <p>
            All in a ConsistentAI model that can be queried immediately.
        </p>

        <p>
            Doctors look over, check and tweak the semantics.
        </p>

        <p>
            Then they ask: <em>"How should a clinician manage chest pain?"</em>
        </p>

        <blockquote className="blog-post-quote">
            "It returned relevant guidance - cited, traceable, grounded in source. Not
            because someone modelled 'chest pain' into a hierarchy. Because the language
            itself carries the semantics."
        </blockquote>

        <h3>The Questions Company A Should Be Asking</h3>

        <p>
            • What will Company B look like in three years?<br />
            • When we finish our ontology programme, will we have to unwind it to compete?<br />
            • Is this one transformation - or two?<br />
            • Is this a multi-year initiative costing millions, or an immediate value
            approach with a fraction of the cost?
        </p>

        <h3>Two Paths to Semantics</h3>

        <p>
            <strong>Path 1:</strong> Model upfront. Define before you use. Years/months
            and millions+ in cost.
        </p>

        <p>
            <strong>Path 2:</strong> Use AI to discover through usage. Let it find and
            encode the structure. Hours and iteration.
        </p>

        <p>
            Both get you semantics.
        </p>

        <p>
            <strong>Only one gets you there at the speed your market is about to demand.</strong> 🎯
        </p>
    </BlogPost>
);

export default TailOfTwoJourneys;
